import { Link } from "react-router-dom";

export default function Section7() {
  return (
    <div className="w-full Section6 pb-[4%] pt-10 md:pt-[80px]">
      <div className="w-full mx-auto section6-container">
        <div className="w-[90%] md:w-[61%] mx-auto text-center pb-[1%]">
          <h2 className="text-[24px] md:text-[34px] font-bold text-[#151515] leading-[29px] md:leading-[41px] my-[0.67em]">
            Our Shopify Stores Outperform The Competition
          </h2>
          <p className="leading-[20px] w-full md:w-[75%] text-[#373737] text-base m-auto font-open">
            Need a professional Shopify website? Over the last 7 years, we’ve
            managed 500+ of eCommerce design and development projects – helping
            clients drive growth in online sales.
          </p>
        </div>

        <div className="w-full flex flex-wrap sxl:flex-nowrap justify-center p-[30px]  md:py-[2%] gap-x-0 min-[1171px]:gap-x-[7%]">
          <img
            src="../../../assets/website-image-shopify.png"
            alt="Website Image One"
            className="cover inline-block md:w-auto py-[10px] md:py-0 w-[90%]"
          />
          <img
            src="../../../assets/website-image-shopify2.png"
            alt="Website Image Two"
            className="cover inline-block md:w-auto w-[90%] py-[10px] md:py-0"
          />
        </div>
      </div>
    </div>
  );
}
